(function (global) {
  "use strict";

  var VALUES = {
    GENDER_MALE: "זכר",
    GENDER_FEMALE: "נקבה",
    CASTRATION_YES: "מסורס",
    CASTRATION_NO: "לא מסורס",
    YES_EXISTS: "כן קיימות",
    NO_EXISTS: "לא קיימות",
    ACTIVITY_INACTIVE: "לא פעיל",
    ACTIVITY_ACTIVE: "פעיל",
    ACTIVITY_VERY: "פעיל מאד",
    BODY_THIN: "רזה",
    BODY_NORMAL: "כמו שצריך",
    BODY_FULL: "מלא",
    PET_TYPE_DOG: "כלב",
  };

  var SCORES = {
    age: { young: 1, senior: 1.2 },
    castration: { yes: 1, no: 1.11 },
    activity: { inactive: 1.2, active: 1.25, veryActive: 1.4 },
    body: { thin: 1.1, normal: 1, heavy: 0.9 },
  };

  var STORAGE_KEYS = {
    quizData: "quizData",
    millsQuiz: "millsQuiz",
    millsCustomer: "millsCustomer",
  };

  var QUIZ_FLAT_STORAGE_KEYS = {
    name: "dog_name",
    gender: "dog_gender",
    castration: "dog_castration",
    weight: "dog_weight",
    age: "dog_age",
    activity: "dog_activity",
    body: "dog_body",
    sensitivities: "dog_sensitivities",
    sensitivities_desc: "dog_sensitivities_desc",
    protein: "dog_protein",
    protein_desc: "dog_protein_desc",
  };

  var QUIZ_FIELD_NAMES = Object.keys(QUIZ_FLAT_STORAGE_KEYS);

  var CALORIES_NO_REC_MAX = 2372;

  var WEIGHT_MIN = 1;
  var WEIGHT_MAX = 86;
  var AGE_MIN = 1;
  var AGE_MAX = 14;

  var ALLERGY_HE_TO_API = { דגים: "fish", דגנים: "dganim", עוף: "chicken" };

  var PROTEIN_HE_TO_API = {
    דגים: "fish",
    עוף: "chicken",
    הודו: "turkey",
    צבי: "deer",
    ברווז: "duck",
  };

  var STRUCTURAL_EMPTY_QUIZDATA = {
    sex: 0,
    age: 0,
    weight: 0,
    sirus: false,
    activity: 0,
    body: 1,
    allergy: "",
    protein: "",
    notes: "",
  };

  var FALLBACK_API_QUIZDATA_UNKNOWN_FIELD = {
    sex: 1,
    body: 2,
    activity: 2,
    sirus: false,
    age: 0,
    weight: 0,
  };

  var CALORIES_FALLBACK_ACTIVITY_LABEL = VALUES.ACTIVITY_VERY;
  var CALORIES_FALLBACK_BODY_LABEL = VALUES.BODY_FULL;

  /** Read one key from localStorage; never throws. */
  function safeGetStorageItem(key) {
    try {
      if (typeof global.localStorage === "undefined" || !global.localStorage) return null;
      return global.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  /** Write one key to localStorage; returns success boolean. */
  function safeSetStorageItem(key, value) {
    try {
      if (typeof global.localStorage === "undefined" || !global.localStorage) return false;
      global.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  /** Coerce value to trimmed string; null/undefined become empty string. */
  function trimToString(v) {
    if (v == null) return "";
    return String(v).trim();
  }

  /** True if trimmed string is non-empty. */
  function isNonEmptyString(v) {
    return trimToString(v) !== "";
  }

  /** Parse a non-negative integer string only; reject decimals and junk. */
  function parseStrictInteger(raw) {
    var s = trimToString(raw);
    if (s === "") return null;
    if (!/^\d+$/.test(s)) return null;
    var n = parseInt(s, 10);
    return isNaN(n) ? null : n;
  }

  /** True if n is a finite number within [min, max] inclusive. */
  function isIntegerInRange(n, min, max) {
    return typeof n === "number" && n >= min && n <= max;
  }

  /** Split CSV, trim parts, drop empties. */
  function splitCsvTrim(str) {
    if (!str || typeof str !== "string") return [];
    var parts = str.split(",");
    var out = [];
    for (var i = 0; i < parts.length; i++) {
      var s = String(parts[i]).trim();
      if (s) out.push(s);
    }
    return out;
  }

  /** Map Hebrew tokens through dict; unknown tokens pass through unchanged. */
  function mapCsvHeToApi(csvStr, dict) {
    var parts = splitCsvTrim(csvStr);
    if (parts.length === 0) return "";
    var mapped = [];
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      mapped.push(Object.prototype.hasOwnProperty.call(dict, p) ? dict[p] : p);
    }
    return mapped.join(",");
  }

  /** True iff value is exactly the business yes-exists answer. */
  function answerIsYesExists(s) {
    return trimToString(s) === VALUES.YES_EXISTS;
  }

  /** True iff sensitivities question is yes. */
  function sensitivitiesAnswerIsYes(s) {
    return answerIsYesExists(s);
  }

  /** True iff protein preference question is yes. */
  function proteinPreferenceAnswerIsYes(s) {
    return answerIsYesExists(s);
  }

  /** Return canonical gender label or null. */
  function normalizeGenderLabel(raw) {
    var g = trimToString(raw);
    if (g === VALUES.GENDER_MALE) return VALUES.GENDER_MALE;
    if (g === VALUES.GENDER_FEMALE) return VALUES.GENDER_FEMALE;
    return null;
  }

  /** Map known gender label to API sex 0/1; unknown returns null. */
  function mapKnownGenderLabelToApiSex(label) {
    if (label === VALUES.GENDER_MALE) return 0;
    if (label === VALUES.GENDER_FEMALE) return 1;
    return null;
  }

  /** Return canonical castration label or null. */
  function normalizeCastrationLabel(raw) {
    var c = trimToString(raw);
    if (c === VALUES.CASTRATION_YES) return VALUES.CASTRATION_YES;
    if (c === VALUES.CASTRATION_NO) return VALUES.CASTRATION_NO;
    return null;
  }

  /** Map known castration label to API boolean; unknown returns null. */
  function mapKnownCastrationLabelToApiSirus(label) {
    if (label === VALUES.CASTRATION_YES) return true;
    if (label === VALUES.CASTRATION_NO) return false;
    return null;
  }

  /** Return canonical body label or null. */
  function normalizeBodyLabel(raw) {
    var b = trimToString(raw);
    if (b === VALUES.BODY_THIN) return VALUES.BODY_THIN;
    if (b === VALUES.BODY_NORMAL) return VALUES.BODY_NORMAL;
    if (b === VALUES.BODY_FULL) return VALUES.BODY_FULL;
    return null;
  }

  /** Map known body label to API 0..2; unknown returns null. */
  function mapKnownBodyLabelToApiCode(label) {
    if (label === VALUES.BODY_THIN) return 0;
    if (label === VALUES.BODY_NORMAL) return 1;
    if (label === VALUES.BODY_FULL) return 2;
    return null;
  }

  /** Return canonical activity label or null. */
  function normalizeActivityLabel(raw) {
    var a = trimToString(raw);
    if (a === VALUES.ACTIVITY_INACTIVE) return VALUES.ACTIVITY_INACTIVE;
    if (a === VALUES.ACTIVITY_ACTIVE) return VALUES.ACTIVITY_ACTIVE;
    if (a === VALUES.ACTIVITY_VERY) return VALUES.ACTIVITY_VERY;
    return null;
  }

  /** Map known activity label to API 0..2; unknown returns null. */
  function mapKnownActivityLabelToApiCode(label) {
    if (label === VALUES.ACTIVITY_INACTIVE) return 0;
    if (label === VALUES.ACTIVITY_ACTIVE) return 1;
    if (label === VALUES.ACTIVITY_VERY) return 2;
    return null;
  }

  /** Parse age for API payload; null if invalid. */
  function parseQuizAgeForApi(raw) {
    var n = parseStrictInteger(raw);
    if (n === null) return null;
    if (!isIntegerInRange(n, AGE_MIN, AGE_MAX)) return null;
    return n;
  }

  /** Parse weight for API payload; null if invalid. */
  function parseQuizWeightForApi(raw) {
    var n = parseStrictInteger(raw);
    if (n === null) return null;
    if (!isIntegerInRange(n, WEIGHT_MIN, WEIGHT_MAX)) return null;
    return n;
  }

  /** Same as API parse; calorie boundary naming. */
  function parseQuizAgeForCalories(raw) {
    return parseQuizAgeForApi(raw);
  }

  /** Same as API parse; calorie boundary naming. */
  function parseQuizWeightForCalories(raw) {
    return parseQuizWeightForApi(raw);
  }

  /** Legacy compat age for kcal when parse returns null. */
  function resolveCompatAgeForCalories(parsedOrNull) {
    if (parsedOrNull !== null) return parsedOrNull;
    return FALLBACK_API_QUIZDATA_UNKNOWN_FIELD.age;
  }

  /** Legacy compat weight for kcal when parse returns null. */
  function resolveCompatWeightKgForCalories(parsedOrNull) {
    if (parsedOrNull !== null) return parsedOrNull;
    return FALLBACK_API_QUIZDATA_UNKNOWN_FIELD.weight;
  }

  /** Normalized model for calorie math only. */
  function buildCaloriesComputationModel(src) {
    var base = src && typeof src === "object" ? src : {};
    var age = resolveCompatAgeForCalories(parseQuizAgeForCalories(base.age));
    var weight = resolveCompatWeightKgForCalories(parseQuizWeightForCalories(base.weight));

    var castrationLabel = normalizeCastrationLabel(base.castration);
    if (castrationLabel === null) castrationLabel = VALUES.CASTRATION_NO;

    var activityLabel = normalizeActivityLabel(base.activity);
    if (activityLabel === null) activityLabel = CALORIES_FALLBACK_ACTIVITY_LABEL;

    var bodyLabel = normalizeBodyLabel(base.body);
    if (bodyLabel === null) bodyLabel = CALORIES_FALLBACK_BODY_LABEL;

    return {
      age: age,
      weight: weight,
      castrationLabel: castrationLabel,
      activityLabel: activityLabel,
      bodyLabel: bodyLabel,
    };
  }

  /** Default row when quiz object is missing. */
  function emptyMillsDogPayload() {
    return {
      name: "",
      quizData: {
        sex: STRUCTURAL_EMPTY_QUIZDATA.sex,
        age: STRUCTURAL_EMPTY_QUIZDATA.age,
        weight: STRUCTURAL_EMPTY_QUIZDATA.weight,
        sirus: STRUCTURAL_EMPTY_QUIZDATA.sirus,
        activity: STRUCTURAL_EMPTY_QUIZDATA.activity,
        body: STRUCTURAL_EMPTY_QUIZDATA.body,
        allergy: STRUCTURAL_EMPTY_QUIZDATA.allergy,
        protein: STRUCTURAL_EMPTY_QUIZDATA.protein,
        notes: STRUCTURAL_EMPTY_QUIZDATA.notes,
      },
    };
  }

  /** Format flat quiz into API dogs payload. */
  function formatMillsQuizData(sub) {
    var emptyDog = emptyMillsDogPayload();
    var fb = FALLBACK_API_QUIZDATA_UNKNOWN_FIELD;
    if (!sub || typeof sub !== "object") {
      return { dogs: [emptyDog] };
    }

    var genderLabel = normalizeGenderLabel(sub.gender);
    var sexApi = mapKnownGenderLabelToApiSex(genderLabel);
    if (sexApi === null) sexApi = fb.sex;

    var castrationLabel = normalizeCastrationLabel(sub.castration);
    var sirusApi = mapKnownCastrationLabelToApiSirus(castrationLabel);
    if (sirusApi === null) sirusApi = fb.sirus;

    var bodyLabel = normalizeBodyLabel(sub.body);
    var bodyApi = mapKnownBodyLabelToApiCode(bodyLabel);
    if (bodyApi === null) bodyApi = fb.body;

    var activityLabel = normalizeActivityLabel(sub.activity);
    var activityApi = mapKnownActivityLabelToApiCode(activityLabel);
    if (activityApi === null) activityApi = fb.activity;

    var allergy = sensitivitiesAnswerIsYes(sub.sensitivities)
      ? mapCsvHeToApi(trimToString(sub.sensitivities_desc), ALLERGY_HE_TO_API)
      : "";

    var protein = proteinPreferenceAnswerIsYes(sub.protein)
      ? mapCsvHeToApi(trimToString(sub.protein_desc), PROTEIN_HE_TO_API)
      : "";

    var ageParsed = parseQuizAgeForApi(sub.age);
    var age = ageParsed !== null ? ageParsed : fb.age;

    var weightParsed = parseQuizWeightForApi(sub.weight);
    var weight = weightParsed !== null ? weightParsed : fb.weight;

    return {
      dogs: [
        {
          name: sub.name != null ? String(sub.name) : "",
          quizData: {
            sex: sexApi,
            age: age,
            weight: weight,
            sirus: sirusApi,
            activity: activityApi,
            body: bodyApi,
            allergy: allergy,
            protein: protein,
            notes: "",
          },
        },
      ],
    };
  }

  /** True if weight is in allowed quiz range. */
  function isValidWeight(w) {
    var n = parseStrictInteger(w);
    return n !== null && isIntegerInRange(n, WEIGHT_MIN, WEIGHT_MAX);
  }

  /** True if age is in allowed quiz range. */
  function isValidAge(a) {
    var n = parseStrictInteger(a);
    return n !== null && isIntegerInRange(n, AGE_MIN, AGE_MAX);
  }

  /** Write one flat field to storage. */
  function persistFlatQuizField(formFieldName, value) {
    var lsKey = QUIZ_FLAT_STORAGE_KEYS[formFieldName];
    if (!lsKey) return;
    var stored = value === undefined || value === null ? "" : String(value);
    safeSetStorageItem(lsKey, stored);
  }

  /** Persist from input element if mapped. */
  function persistFlatFromInput(input) {
    if (!input || !input.name) return;
    if (!QUIZ_FLAT_STORAGE_KEYS[input.name]) return;
    var v = input.value != null ? input.value : "";
    persistFlatQuizField(input.name, v);
  }

  /** Read all non-empty flat fields. */
  function readFlatFields() {
    var d = {};
    for (var i = 0; i < QUIZ_FIELD_NAMES.length; i++) {
      var formName = QUIZ_FIELD_NAMES[i];
      var raw = safeGetStorageItem(QUIZ_FLAT_STORAGE_KEYS[formName]);
      if (raw === null || raw === "") continue;
      d[formName] = raw;
    }
    return d;
  }

  /** True if any tracked field has content. */
  function hasMeaningfulDraft(d) {
    if (!d || typeof d !== "object") return false;
    for (var i = 0; i < QUIZ_FIELD_NAMES.length; i++) {
      if (isNonEmptyString(d[QUIZ_FIELD_NAMES[i]])) return true;
    }
    return false;
  }

  /** Public API no-op; legacy migration hook. */
  function migrateLegacyDraft() {}

  /** Resolve selector, element, or jQuery to a form element. */
  function resolveFormElement(formOrSelector) {
    if (!formOrSelector) return null;
    if (typeof formOrSelector === "string") {
      return document.querySelector(formOrSelector);
    }
    if (formOrSelector.jquery && formOrSelector.length) {
      return formOrSelector[0] || null;
    }
    if (formOrSelector.nodeType === 1) {
      return formOrSelector;
    }
    return null;
  }

  /** Multi-value field helper for serializeForm. */
  function pushFieldValue(o, name, val) {
    if (o[name] !== undefined) {
      if (!o[name].push) o[name] = [o[name]];
      o[name].push(val);
    } else {
      o[name] = val;
    }
  }

  /** Serialize form to plain object. */
  function serializeForm(formOrSelector) {
    var form = resolveFormElement(formOrSelector);
    if (!form || form.nodeName !== "FORM") return {};
    var o = {};
    var els = form.elements;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el.name) continue;
      var tag = el.nodeName;
      var type = (el.type || "").toLowerCase();
      if (type === "file" || type === "submit" || type === "button" || type === "reset") continue;
      if (tag === "INPUT" && (type === "checkbox" || type === "radio")) {
        if (!el.checked) continue;
      }
      if (tag === "SELECT" && el.multiple) {
        var opts = el.options;
        var j;
        for (j = 0; j < opts.length; j++) {
          if (opts[j].selected) {
            pushFieldValue(o, el.name, opts[j].value || "");
          }
        }
        continue;
      }
      pushFieldValue(o, el.name, el.value != null ? el.value : "");
    }
    return o;
  }

  /** Sync flat storage keys from a form. */
  function syncAllFlatFromForm(formSelector) {
    var form = resolveFormElement(formSelector);
    if (!form || form.nodeName !== "FORM") return;
    var o = serializeForm(form);
    for (var i = 0; i < QUIZ_FIELD_NAMES.length; i++) {
      var fn = QUIZ_FIELD_NAMES[i];
      if (!Object.prototype.hasOwnProperty.call(o, fn)) continue;
      persistFlatQuizField(fn, o[fn]);
    }
  }

  /** Save legacy JSON blob. */
  function saveQuizData(formData) {
    if (formData === undefined) return;
    var json;
    try {
      json = JSON.stringify(formData);
    } catch (e) {
      return;
    }
    safeSetStorageItem(STORAGE_KEYS.quizData, json);
  }

  /** Load from flat keys or null. */
  function loadQuizDataFromFlat() {
    var d = readFlatFields();
    if (!hasMeaningfulDraft(d)) return null;
    d.type = VALUES.PET_TYPE_DOG;
    return d;
  }

  /** Load from legacy quizData key. */
  function loadQuizDataFromLegacyJsonKey() {
    var raw = safeGetStorageItem(STORAGE_KEYS.quizData);
    if (raw === null || raw === "") return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  /** Flat first, then legacy JSON. */
  function loadQuizData() {
    var flat = loadQuizDataFromFlat();
    if (flat) return flat;
    return loadQuizDataFromLegacyJsonKey();
  }

  /** Public API no-op; reserved for callers. */
  function removeLegacyDraftKey() {}

  /** Save millsQuiz when customer id present. */
  function saveQuizDataSubFormat(data) {
    var cid = safeGetStorageItem(STORAGE_KEYS.millsCustomer);
    if (!cid) return;
    var sub = data;
    if (!sub) {
      sub = loadQuizDataFromFlat();
    }
    if (!sub) return;
    var quizData = formatMillsQuizData(sub);
    var cookie = { status: null, dogs: quizData.dogs };
    var json;
    try {
      json = JSON.stringify(cookie);
    } catch (e) {
      return;
    }
    safeSetStorageItem(STORAGE_KEYS.millsQuiz, json);
  }

  /** RER baseline (kg). */
  function nominalCaloriesBase(weightKg) {
    var w = typeof weightKg === "number" && isFinite(weightKg) ? weightKg : 0;
    return 70 * Math.pow(w, 0.75);
  }

  /** Age band multiplier. */
  function resolveAgeScore(age) {
    var a = typeof age === "number" && isFinite(age) ? age : 0;
    return a <= 9 ? SCORES.age.young : SCORES.age.senior;
  }

  /** Castration multiplier from label. */
  function resolveCastrationScoreFromLabel(castrationLabel) {
    if (castrationLabel === VALUES.CASTRATION_YES) return SCORES.castration.yes;
    return SCORES.castration.no;
  }

  /** Activity multiplier from label. */
  function resolveActivityScoreFromLabel(activityLabel) {
    if (activityLabel === VALUES.ACTIVITY_INACTIVE) return SCORES.activity.inactive;
    if (activityLabel === VALUES.ACTIVITY_ACTIVE) return SCORES.activity.active;
    return SCORES.activity.veryActive;
  }

  /** Body multiplier from label. */
  function resolveBodyScoreFromLabel(bodyLabel) {
    if (bodyLabel === VALUES.BODY_THIN) return SCORES.body.thin;
    if (bodyLabel === VALUES.BODY_NORMAL) return SCORES.body.normal;
    return SCORES.body.heavy;
  }

  /** Recommended daily kcal. */
  function computeCalories(parsedQuizData) {
    var m = buildCaloriesComputationModel(parsedQuizData);
    var ageScore = resolveAgeScore(m.age);
    var castrationScore = resolveCastrationScoreFromLabel(m.castrationLabel);
    var activityScore = resolveActivityScoreFromLabel(m.activityLabel);
    var bodyScore = resolveBodyScoreFromLabel(m.bodyLabel);
    var nominal = nominalCaloriesBase(m.weight);
    var calories;
    if (m.age > 9) {
      calories = nominal * ageScore;
    } else if (m.activityLabel === VALUES.ACTIVITY_INACTIVE) {
      calories = nominal * ageScore * activityScore * bodyScore;
    } else {
      calories = nominal * ageScore * castrationScore * activityScore * bodyScore;
    }
    return Math.round(calories);
  }

  /** Public alias. */
  function sensitivitiesMeansYes(s) {
    return sensitivitiesAnswerIsYes(s);
  }

  /** Public alias. */
  function proteinMeansYes(s) {
    return proteinPreferenceAnswerIsYes(s);
  }

  var engine = {
    VALUES: VALUES,
    SCORES: SCORES,
    STORAGE_KEYS: STORAGE_KEYS,
    QUIZ_FLAT_STORAGE_KEYS: QUIZ_FLAT_STORAGE_KEYS,
    QUIZ_FIELD_NAMES: QUIZ_FIELD_NAMES,
    CALORIES_NO_REC_MAX: CALORIES_NO_REC_MAX,
    WEIGHT_MIN: WEIGHT_MIN,
    WEIGHT_MAX: WEIGHT_MAX,
    AGE_MIN: AGE_MIN,
    AGE_MAX: AGE_MAX,

    persistFlatQuizField: persistFlatQuizField,
    persistFlatFromInput: persistFlatFromInput,
    readFlatFields: readFlatFields,
    hasMeaningfulDraft: hasMeaningfulDraft,
    migrateLegacyDraft: migrateLegacyDraft,
    syncAllFlatFromForm: syncAllFlatFromForm,
    saveQuizData: saveQuizData,
    loadQuizData: loadQuizData,
    loadQuizDataFromFlat: loadQuizDataFromFlat,
    removeLegacyDraftKey: removeLegacyDraftKey,
    saveQuizDataSubFormat: saveQuizDataSubFormat,
    serializeForm: serializeForm,

    computeCalories: computeCalories,
    isValidWeight: isValidWeight,
    isValidAge: isValidAge,

    formatMillsQuizData: formatMillsQuizData,
    splitCsvTrim: splitCsvTrim,
    mapCsvHeToApi: mapCsvHeToApi,
    sensitivitiesMeansYes: sensitivitiesMeansYes,
    proteinMeansYes: proteinMeansYes,
  };

  global.MillsQuizEngine = engine;

  global.MillsQuiz = {
    VALUES: VALUES,
    splitCsvTrim: splitCsvTrim,
    mapCsvHeToApi: mapCsvHeToApi,
    formatMillsQuizData: formatMillsQuizData,
    sensitivitiesMeansYes: sensitivitiesMeansYes,
    proteinMeansYes: proteinMeansYes,
  };
})(typeof window !== "undefined" ? window : this);
